import i18next from "i18next";
const processAppointmentClinic = () => {
    const appointmentClinics_rootSource = [
        {
            id: "ottawa",
            text: i18next.t("clinics:ottawa"),
            acronym: i18next.t("common:omc"),
            filtered: true,
        },
        {
            id: "montreal",
            text: i18next.t("clinics:montreal"),
            acronym: i18next.t("common:mmc"),
            filtered: true,
        },
    ];
    let appointmentClinics;
    if (localStorage.appointment_clinics) {
        appointmentClinics = JSON.parse(localStorage.appointment_clinics);
    } else {
        appointmentClinics = appointmentClinics_rootSource;
    }
    return appointmentClinics;
};
export default processAppointmentClinic;
